import { useState, useMemo, useEffect } from "react";
import {
    CircularProgress,
    Typography,
    Box,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    Modal,
    Button,
    IconButton,
    Tooltip,
} from "@mui/material";
import { FaTrashCan } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { DataGrid } from "@mui/x-data-grid";
import { useGetIngresosMasivos, useIngresoPaciente } from "../../../Services/IngresoPaciente";
import { useGetSucursal } from "../../../Services/Sucursales";
import { Texto, buttonGuardar, SubTitulo, InputDescripcion, Input, inputFecha, modalStyle, InputBuscador, buttonCancelar, buttonAtras } from "../../../Layouts/CustomStyles";
import { useGetProfesional } from "../../../Services/Profesional";
import { DiseñoDataGrid } from "../../FuncionesGenerales/DataGrid";
import { FormatRut } from "../../FuncionesGenerales/Rut";
import { formatCLP } from "../../FuncionesGenerales/FormatoCLP";
import { FaHistory } from "react-icons/fa";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { useGetPrevision } from "../../../Services/Prevision";


export const IndexCargaMasiva = ({ actualizarTabla }) => {
    const { Prevision } = useGetPrevision();
    const { ingresosPacientes, loadingsIngresos, errorIngresos, refetchIP, } = useGetIngresosMasivos();
    const { editarIngresoPaciente, eliminarIngresoPaciente } = useIngresoPaciente();
    const { sucursales, loadings: loadSucursales, error: errorSucursales } = useGetSucursal();
    const { profesional } = useGetProfesional();
    const [sucursal, setSucursal] = useState("");
    const [mes, setMes] = useState("");
    const [anio, setAnio] = useState("");
    const [openEdit, setOpenEdit] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [selectedIngreso, setSelectedIngreso] = useState(null);
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [openHistorial, setOpenHistorial] = useState(false);
    const [historialSeleccionado, setHistorialSeleccionado] = useState([]);
    const [pacienteSeleccionado, setPacienteSeleccionado] = useState(null);
    const [openObs, setOpenObs] = useState(false);
    const [obsSeleccionada, setObsSeleccionada] = useState("");
    const [tipoFecha, setTipoFecha] = useState("");
const [estadoPaciente, setEstadoPaciente] = useState("");

    const profesionalesFiltrados = profesional.filter((p) => {
    // Excluir los del área 1 siempre
    if (p.id_area_servicio === "5") return false;

    // Si seleccionó "Mostrar todos"
    if (selectedIngreso?.kine === "TODOS") return true;

    // Si NO selecciona sucursal → mostrar todos
    if (!selectedIngreso?.branch_id) return true;
     
    // Filtrar por sucursal
    return (
        p.sucursal_uno === selectedIngreso.branch_name ||
        p.sucursal_dos === selectedIngreso.branch_name
    );
});



   useEffect(() => {

  refetchIP({
    branch_id: sucursal || undefined,
    mes: mes || undefined,
    anio: anio || undefined,
    estado_paciente: estadoPaciente || undefined,
    tipo_fecha: tipoFecha
  });

}, [
  sucursal,
  mes,
  anio,
  estadoPaciente,
  tipoFecha
]);

    const handleOpenHistorial = (row) => {
        setHistorialSeleccionado(row.pagos_deudor || []);
        setPacienteSeleccionado(row.nombre_paciente);
        setOpenHistorial(true);
    };

    const handleCloseHistorial = () => {
        setOpenHistorial(false);
    };
    const handleOpenEdit = (row) => {
        setSelectedIngreso(row);
        setOpenEdit(true);
    };

    const handleCloseEdit = () => {
        setOpenEdit(false);
        setSelectedIngreso(null);
    };

    const handleEditarIngreso = async () => {
        if (!selectedIngreso) return;

        try {
            setEnviandoAlert(true);

            const payload = {
                fecha: selectedIngreso.fecha,
                fecha_pago: selectedIngreso.fecha_pago,
                rut: selectedIngreso.rut,
                nombre_paciente: selectedIngreso.nombre_paciente,
                estado_paciente: selectedIngreso.estado_paciente,
                estado_pago: selectedIngreso.estado_pago,
                prevision: selectedIngreso.prevision,
                medico_tratante: selectedIngreso.medico_tratante,
                branch_id: selectedIngreso.branch_id,
                kine: selectedIngreso.kine,
                n_sesiones: selectedIngreso.n_sesiones,
                episodio: selectedIngreso.episodio !== null && selectedIngreso.episodio !== undefined
  ? String(selectedIngreso.episodio)
  : null,
                monto: selectedIngreso.monto,
                valor: selectedIngreso.monto, // ⚠️ sincronizado
                observaciones: selectedIngreso.observaciones,
            };


            await editarIngresoPaciente(selectedIngreso.id, payload);

            setAlertMessage("Ingreso actualizado correctamente ✅");
            setSuccessAlertOpen(true);
            refetchIP(); // recarga la lista
            handleCloseEdit(); // cierra el modal
        } catch (error) {
            setAlertMessage(`Error al actualizar: ${error}`);
            setErrorAlertOpen(true);
        } finally {
            setEnviandoAlert(false);
        }
    };

    const handleOpenDelete = (row) => {
        setSelectedIngreso(row);
        setOpenDelete(true);
    };

    const handleCloseDelete = () => {
        setOpenDelete(false);
        setSelectedIngreso(null);
    };

    const handleEliminarIngreso = async () => {
        if (!selectedIngreso) return;

        try {
            setEnviandoAlert(true);

            await eliminarIngresoPaciente(selectedIngreso.id); // llama al API DELETE

            setAlertMessage("Ingreso eliminado correctamente ✅");
            setSuccessAlertOpen(true);
            refetchIP(); // recarga la lista
            handleCloseDelete();
        } catch (error) {
            setAlertMessage(`Error al eliminar: ${error}`);
            setErrorAlertOpen(true);
        } finally {
            setEnviandoAlert(false);
        }
    };

    const meses = [
  { value: 1, label: "Enero" },
  { value: 2, label: "Febrero" },
  { value: 3, label: "Marzo" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Mayo" },
  { value: 6, label: "Junio" },
  { value: 7, label: "Julio" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Septiembre" },
  { value: 10, label: "Octubre" },
  { value: 11, label: "Noviembre" },
  { value: 12, label: "Diciembre" },
];



const anioActual = new Date().getFullYear();

const anios = Array.from(
  { length: 5 },
  (_, i) => anioActual - i
);

    const columns = [
        {
            field: "fecha",
            headerName: "Fecha",
            width: 130,
            renderCell: (params) => {
                const fecha = new Date(params.row.fecha);
                const dia = fecha.getUTCDate();
                const mes = fecha.getUTCMonth() + 1;
                const anio = fecha.getUTCFullYear();
                return `${dia.toString().padStart(2, '0')}-${mes.toString().padStart(2, '0')}-${anio}`;
            }
        },

        {
            field: "estado_paciente", headerName: "Estado Paciente", width: 180, renderCell: (params) => {
                const nombre = params.value || "";
                // Convierte la primera letra en mayúscula y el resto en minúsculas
                const formateado =
                    nombre.charAt(0).toUpperCase() + nombre.slice(1).toLowerCase();

                return (
                    <span style={{ textTransform: "capitalize", fontFamily: "Poppins" }}>
                        {formateado}
                    </span>
                );
            },
        },
        {
            field: "nombre_paciente", headerName: "Nombre Paciente", width: 180, renderCell: (params) => {
                const nombre = params.value || "";
                // Convierte la primera letra en mayúscula y el resto en minúsculas
                const formateado =
                    nombre.charAt(0).toUpperCase() + nombre.slice(1).toLowerCase();

                return (
                    <span style={{ textTransform: "capitalize", fontFamily: "Poppins" }}>
                        {formateado}
                    </span>
                );
            },
        },
        { field: "rut", headerName: "Rut", width: 120, renderCell: (params) => FormatRut(params.value) },
        {
            field: "prevision", headerName: "Previsión", width: 120, renderCell: (params) => {
                const nombre = params.value || "";
                // Convierte la primera letra en mayúscula y el resto en minúsculas
                const formateado =
                    nombre.charAt(0).toUpperCase() + nombre.slice(1).toLowerCase();

                return (
                    <span style={{ textTransform: "capitalize", fontFamily: "Poppins" }}>
                        {formateado}
                    </span>
                );
            },
        },
        {
            field: "kine", headerName: "Kinesiólogo", width: 150, renderCell: (params) => {
                const nombre = params.value || "";
                // Convierte la primera letra en mayúscula y el resto en minúsculas
                const formateado =
                    nombre.charAt(0).toUpperCase() + nombre.slice(1).toLowerCase();

                return (
                    <span style={{ textTransform: "capitalize", fontFamily: "Poppins" }}>
                        {formateado}
                    </span>
                );
            },
        },
        { field: "n_sesiones", headerName: "Sesiones", width: 110 },
        { field: "medico_tratante", headerName: "Medico Tratante", width: 150 },
        {
            field: "episodio",
            headerName: "Episodio",
            width: 180,
            renderCell: (params) => {
                const episodio = params.row.episodio ?? "—";
                const tienePagos = params.row.pagos_deudor?.length > 0;

                return (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <span>{episodio}</span>

                        {tienePagos && (
                            <Box
                                onClick={() => handleOpenHistorial(params.row)}
                                sx={{
                                    cursor: "pointer",
                                    backgroundColor: "#77c3c571",
                                    borderRadius: "50%",
                                    padding: "6px",
                                    border: "2px solid #1a73e8",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <FaHistory size={25} color="#1a73e8" />
                            </Box>
                        )}

                    </Box>
                );
            },
        },

        { field: "fecha_pago", headerName: "fecha Pago", width: 130 },
        { field: "monto", headerName: "Monto", width: 110, renderCell: (params) => formatCLP(params.value) },
        { field: "estado_pago", headerName: "Estado Pago", width: 130 },
        {
            field: "branch_id",
            headerName: "Sucursal",
            width: 150,
            renderCell: (params) => {
                if (!params?.row?.branch_id) return "-";

                // Convertimos a número por seguridad
                const branchId = Number(params.row.branch_id);

                // Buscamos la sucursal por ID
                const suc = sucursales.find((s) => Number(s.id) === branchId);

                return suc ? suc.name : "-";
            },
        },
        {
            field: "observaciones",
            headerName: "Observaciones",
            width: 130,
            renderCell: (params) => {
                const tieneObs =
                    params.row.observaciones &&
                    params.row.observaciones.trim() !== "";

                return tieneObs ? (
                    <Tooltip title="Ver observación">
                        <IconButton
                            onClick={() => {
                                setObsSeleccionada(params.row.observaciones);
                                setOpenObs(true);
                            }}
                            sx={{ color: "#2a8d74" }}
                        >
                            <ChatBubbleOutlineIcon />
                        </IconButton>
                    </Tooltip>
                ) : (
                    <Typography sx={{ color: "#777", fontSize: "14px" }}>—</Typography>
                );
            },
        },

        {
            field: "acciones",
            headerName: "Acción",
            width: 150,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            display: "flex",
                            gap: 1,
                            width: 150,
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <button className="edit-button" onClick={() => handleOpenEdit(params.row)}>
                            <svg className="edit-svgIcon" viewBox="0 0 512 512">
                                <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32z" />
                            </svg>
                        </button>
                        <button className="delete-button" onClick={() => handleOpenDelete(params.row)}>
                            <FaTrashCan className="delete-svgIcon" />
                        </button>
                    </Box>
                );
            },
        },
    ];




    return (
        <Box mt={3}>
            {/* --- Filtros --- */}
            <Stack direction="row" spacing={2} mb={3}>
                {/* Select sucursal desde tu hook */}
                <FormControl sx={{ ...InputBuscador, minWidth: 180 }}>
                    <InputLabel>Sucursal</InputLabel>
                    <Select
                        value={sucursal}
                        onChange={(e) => {
                            setSucursal(e.target.value);
                            setMes("");
                            setAnio("");
                            
                        }}
                    >
                        <MenuItem value="">Todas</MenuItem>
                        {sucursales.map((s) => (
                            <MenuItem key={s.id} value={s.id.toString()}>
                                {s.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {/* Select mes */}
                <FormControl sx={{ ...InputBuscador, minWidth: 130 }}>
                    <InputLabel>Mes</InputLabel>
                    <Select
                        value={mes}
                        onChange={(e) => {
                            setMes(e.target.value);
                            setAnio("");
                           
                        }}
                    >
                        <MenuItem value="">Todos</MenuItem>
                        {meses.map((m) => (
    <MenuItem key={m.value} value={m.value}>
        {m.label}
    </MenuItem>
))}
                    </Select>
                </FormControl>

                {/* Select año */}
                <FormControl sx={{ ...InputBuscador, minWidth: 120 }}>
                    <InputLabel>Año</InputLabel>
                    <Select
                        value={anio}
                        onChange={(e) => {
                            setAnio(e.target.value);
                           
                        }}
                    >
                        <MenuItem value="">Todos</MenuItem>
                        {anios.map((a) => (
                            <MenuItem key={a} value={a}>{a}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl sx={{ ...InputBuscador, minWidth: 180 }}>
    <InputLabel>Estado</InputLabel>
    <Select
        value={estadoPaciente}
        onChange={(e) => setEstadoPaciente(e.target.value)}
    >
        <MenuItem value="">Todos</MenuItem>
        <MenuItem value="INGRESO">Ingreso</MenuItem>
        <MenuItem value="REINGRESO">Reingreso</MenuItem>
        <MenuItem value="EN TERAPIA">En Terapia</MenuItem>
        <MenuItem value="POSTUROGRAFO">Posturógrafo</MenuItem>
        <MenuItem value="PENDIENTE">Pendiente</MenuItem>
    </Select>
</FormControl>
               
               <FormControl sx={{ ...InputBuscador, minWidth: 180 }}>
    <InputLabel>Filtrar por</InputLabel>
    <Select
        value={tipoFecha}
        onChange={(e) => setTipoFecha(e.target.value)}
    >
         <MenuItem value="">
            Todos
        </MenuItem>
        <MenuItem value="fecha_pago">
            Fecha Pago
        </MenuItem>

        <MenuItem value="fecha">
            Fecha Registro
        </MenuItem>
    </Select>
</FormControl>
            </Stack>

            {/* --- Tabla de ingresos --- */}
            <Box sx={{ height: 600, width: "100%" }}>
                <DataGrid
                    rows={
    ingresosPacientes
        ? [...ingresosPacientes].sort(
            (a, b) =>
                new Date(b.fecha) -
                new Date(a.fecha)
        )
        : []
}
                    columns={columns}
                    pageSizeOptions={[10, 25, 50]}
                    loading={loadingsIngresos}
                    
                    initialState={{
                        pagination: { paginationModel: { pageSize: 10, page: 0 } },
                    }}
                    slots={{ noRowsOverlay: DiseñoDataGrid }}
                    getRowId={(row) => row.id}
                    getRowClassName={(params) => {
                        const estado = params.row.estado_pago?.toUpperCase();
                        if (estado === "NO PAGO") return "nopagado";
                        if (estado === "LIBERADO") return "liberado";
                        if (estado === "PROCESO") return "proceso"; // 🔶 nuevo
                        return "";
                    }}
                    sx={{
                        fontFamily: "Poppins, sans-serif",
                        "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: "#f0f0f0",
                            fontWeight: 600,
                        },
                        "& .nopagado": {
                            bgcolor: "#ea838364", // rojo clarito
                            color: "#5b1111",     // texto rojo oscuro
                            "&:hover": { bgcolor: "#ea8383", color: "#fff" },
                        },
                        "& .liberado": {
                            bgcolor: "#f1a7677f", // naranja clarito
                            color: "#b35400",     // texto naranja oscuro
                            "&:hover": { bgcolor: "#efa330ff", color: "#fff" },
                        },
                        "& .proceso": {
                            bgcolor: "#fff3b0", // amarillo clarito
                            color: "#8f8303ff",   // texto amarillo oscuro
                            "&:hover": { bgcolor: "#b69308ff", color: "#ffffffff" }, // más intenso al pasar el mouse
                        },
                    }}
                />


            </Box>
            <Dialog open={openEdit} onClose={handleCloseEdit} fullWidth maxWidth="sm">
                <DialogTitle sx={Texto}>Editar Ingreso</DialogTitle>
                <DialogContent>
                    {/* Aquí puedes poner un formulario con los campos de `selectedIngreso` */}
                    <Box sx={{ display: "flex", mt: 2, gap: 2, mb: 2 }}>
                        {/* Fecha */}
                        <TextField
                            sx={inputFecha}
                            label="Fecha"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={selectedIngreso?.fecha || ""}
                            onChange={(e) =>
                                setSelectedIngreso({ ...selectedIngreso, fecha: e.target.value })
                            }
                            fullWidth
                        />
                        <TextField
                            sx={inputFecha}
                            label="Fecha de Pago"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={selectedIngreso?.fecha_pago || ""}
                            onChange={(e) =>
                                setSelectedIngreso({ ...selectedIngreso, fecha_pago: e.target.value })
                            }
                            fullWidth
                        />
                    </Box>
                     <Box sx={{ mb: 2 }}>
                        <FormControl fullWidth sx={Input}>
                            <InputLabel id="estado-pago-label">Estado de pago</InputLabel>
                            <Select
                                labelId="estado-pago-label"
                                name="estado_pago"
                                value={selectedIngreso?.estado_pago || ""} // <-- esto debe ser exactamente lo que hay en la BD
                                onChange={(e) =>
                                    setSelectedIngreso({ ...selectedIngreso, estado_pago: e.target.value })
                                }
                                label="Estado de pago"
                            >
                                <MenuItem value="">General</MenuItem>
                                <MenuItem value="PAGADO">Pagado</MenuItem>
                                <MenuItem value="NO PAGO">No Pagado</MenuItem>
                                
                            </Select>
                        </FormControl>
                    </Box>
                    <Box sx={{ mb: 2 }}>
                        <TextField
                            sx={Input}
                            label="RUT"
                            fullWidth
                            margin="dense"
                            value={selectedIngreso?.rut || ""}
                            onChange={(e) => {
                                const valorFormateado = FormatRut(e.target.value);
                                setSelectedIngreso({ ...selectedIngreso, rut: valorFormateado });
                            }}
                        />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                        <TextField
                            sx={Input}
                            label="Nombre Paciente"
                            fullWidth
                            margin="dense"
                            value={selectedIngreso?.nombre_paciente || ""}

                            onChange={(e) =>
                                setSelectedIngreso({ ...selectedIngreso, nombre_paciente: e.target.value })
                            }
                        />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                        <FormControl fullWidth sx={Input}>
                            <InputLabel id="estado-paciente-label">Estado del Paciente</InputLabel>
                            <Select
                                labelId="estado-paciente-label"
                                name="estado_paciente"
                                value={selectedIngreso?.estado_paciente || ""} // <-- esto debe ser exactamente lo que hay en la BD
                                onChange={(e) =>
                                    setSelectedIngreso({ ...selectedIngreso, estado_paciente: e.target.value })
                                }
                                label="Estado del Paciente"
                            >
                                <MenuItem value="">General</MenuItem>
                                <MenuItem value="INGRESO">Ingreso</MenuItem>
                                <MenuItem value="REINGRESO">Reingreso</MenuItem>
                                <MenuItem value="EN TERAPIA">Terapia</MenuItem> {/* Si tu BD tiene EN TERAPIA */}
                                <MenuItem value="POSTUROGRAFO">Posturografo</MenuItem>
                                <MenuItem value="PENDIENTE">Pendiente</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                    <Box sx={{ mb: 2 }}>
                         {selectedIngreso?.prevision &&
     !Prevision?.some(p => p.nombre === selectedIngreso.prevision) && (
        <Typography variant="body2" color="text.secondary" mt={2} mb={2} sx={{marginLeft:2}}>
            La previsión indicada es:&nbsp;
            <strong>{selectedIngreso.prevision}</strong>
        </Typography>
    )}
                        <FormControl fullWidth sx={Input}>

                            
                            <InputLabel id="prevision-label">Previsión</InputLabel>
                         
                          {/* TEXTO cuando NO viene del select */}
   
                            <Select
                                labelId="prevision-label"
                                name="prevision"
                                value={selectedIngreso?.prevision || ""} // <-- esto debe ser exactamente lo que hay en la BD
                                onChange={(e) =>
                                    setSelectedIngreso({ ...selectedIngreso, prevision: e.target.value })
                                }
                                label="Previsión"
                            >
                                <MenuItem value="">Seleccionar...</MenuItem>

                                {Prevision?.map((item) => (
                                    <MenuItem key={item.id} value={item.nombre}>
                                        {item.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>

                    <Box sx={{ mb: 2 }}>
                        <TextField
                            sx={Input}
                            label="Medico Tratante"
                            fullWidth
                            margin="dense"
                            value={selectedIngreso?.medico_tratante || ""}

                            onChange={(e) =>
                                setSelectedIngreso({ ...selectedIngreso, medico_tratante: e.target.value })
                            }
                        />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                        <FormControl fullWidth sx={Input}>
                            <InputLabel id="sucursal-label">Sucursal</InputLabel>
                            <Select
                                labelId="sucursal-label"
                                name="sucursal"
                                value={selectedIngreso?.branch_id || ""}
                                onChange={(e) => {
                                    const selectedId = e.target.value;
                                    const selectedSucursal = sucursales.find(s => s.id === selectedId);

                                    setSelectedIngreso({
                                        ...selectedIngreso,
                                        branch_id: selectedId,
                                        branch_name: selectedSucursal?.name || "",
                                    });
                                }}
                                label="Sucursal"
                            >
                                <MenuItem value="">General</MenuItem>
                                {sucursales?.map((s) => (
                                    <MenuItem key={s.id} value={s.id}>
                                        {s.name}
                                    </MenuItem>
                                ))}
                            </Select>

                        </FormControl>
                    </Box>
                   <Box sx={{ mb: 2 }}>
                     <Typography variant="body2" color="text.secondary" mt={2} mb={2} sx={{marginLeft:2}}>
            el profesional es:&nbsp;
            <strong>{selectedIngreso?.kine}</strong>
        </Typography> 
    <FormControl fullWidth sx={Input}>
        <InputLabel id="profesional-label">Profesional</InputLabel>
        
        <Select
            labelId="profesional-label"
            name="kine"
            value={selectedIngreso?.kine || ""}
            onChange={(e) =>
                setSelectedIngreso({ ...selectedIngreso, kine: e.target.value })
            }
            label="Profesional"
        >
            <MenuItem value="">ver profesional sucursal</MenuItem>
            <MenuItem value="TODOS">Mostrar todos los profesionales</MenuItem>

            {(profesionalesFiltrados || [])
    .filter(p => p)
    .map((p) => (
        <MenuItem key={p.id} value={p.nombre}>
            {p.nombre}
        </MenuItem>
))}
        </Select>
    </FormControl>
</Box>


                    <Box sx={{ mb: 2 }}>
                        <TextField
                            sx={Input}
                            label="Sesiones"
                            fullWidth
                            margin="dense"
                             value={selectedIngreso?.n_sesiones ?? ""}

                            onChange={(e) =>
                                setSelectedIngreso({ ...selectedIngreso, n_sesiones: e.target.value })
                            }
                        />
                    </Box>
                            <Box sx={{ mb: 2 }}>
                                <TextField
                                    sx={Input}
                                    label="Episodio"
                                    fullWidth
                                    margin="dense"
                                    value={selectedIngreso?.episodio || ""}

                                    onChange={(e) =>
                                        setSelectedIngreso({ ...selectedIngreso, episodio: e.target.value })
                                    }
                                />
                            </Box>
                    <Box sx={{ mb: 2 }}>
                        <TextField
                            sx={Input}

                            fullWidth
                            margin="dense"
                            value={formatCLP(selectedIngreso?.monto)}
                            onChange={(e) => {
                                // eliminar todo lo que no sea número
                                const numericValue = e.target.value.replace(/\D/g, "");

                                // actualizar monto y valor simultáneamente
                                setSelectedIngreso({
                                    ...selectedIngreso,
                                    monto: numericValue,
                                    valor: numericValue,
                                });
                            }}
                        />

                    </Box>
                    <Box>
                        <TextField
                            sx={InputDescripcion}
                            label="Observaciones"
                            fullWidth
                            margin="dense"
                            value={selectedIngreso?.observaciones || ""}

                            onChange={(e) =>
                                setSelectedIngreso({ ...selectedIngreso, observaciones: e.target.value })
                            }
                        />

                    </Box>
                    {/* Agrega más campos según necesites */}
                </DialogContent>
                <DialogActions>
                    <Button sx={buttonCancelar} onClick={handleCloseEdit}>Cancelar</Button>
                    <Button sx={buttonGuardar} onClick={handleEditarIngreso}>
                        {enviandoAlert ? "Guardando..." : "Guardar"}
                    </Button>

                </DialogActions>
            </Dialog>


            <Dialog open={openDelete} onClose={handleCloseDelete}>
                <DialogTitle sx={Texto}>Eliminar Ingreso</DialogTitle>
                <DialogContent sx={SubTitulo}>
                    ¿Estás seguro que quieres eliminar a {selectedIngreso?.nombre_paciente}?
                </DialogContent>
                <DialogActions>
                    <Button sx={buttonAtras} onClick={handleCloseDelete}>Cancelar</Button>
                    <Button
                        onClick={handleEliminarIngreso} // 👈 usamos la función con alert y refetch
                        sx={buttonCancelar}
                    >
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openHistorial} onClose={handleCloseHistorial} fullWidth maxWidth="sm" scroll="paper"   >
                <DialogTitle
                    sx={{
                        color: '#585857',
                        fontFamily: 'Poppins',
                        fontWeight: '500',
                        textTransform: 'capitalize',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,     // espacio entre ícono y texto
                    }}
                >
                    <FaHistory size={22} color="#1a73e8" />
                    Historial episodios
                </DialogTitle>
                <DialogTitle
                    sx={{
                        color: '#585857',
                        fontFamily: 'Poppins',
                        fontWeight: '500',
                        textTransform: 'capitalize',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,     // espacio entre ícono y texto
                    }}
                >
                    {pacienteSeleccionado}
                </DialogTitle>


                <DialogContent dividers>
                    {historialSeleccionado.length === 0 ? (
                        <p>No tiene registros de pago.</p>
                    ) : (
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            {historialSeleccionado.map((pago) => (
                                <Box
                                    key={pago.id}
                                    sx={{
                                        padding: 2,
                                        borderRadius: 2,
                                        border: "1px solid #ddd",
                                        background: "#fafafa",
                                    }}
                                >
                                    <p><strong>Fecha:</strong> {pago.fecha_pago}</p>
                                    <p><strong>Monto pagado:</strong> {formatCLP(pago.monto_pagado)}</p>
                                    <p><strong>Sesiones pagadas:</strong> {pago.sesiones_pagadas}</p>
                                    <p><strong>Episodios:</strong> {pago.episodios || "—"}</p>
                                </Box>
                            ))}
                        </Box>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button sx={buttonCancelar} onClick={handleCloseHistorial}>Cerrar</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openObs} onClose={() => setOpenObs(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ fontFamily: "Poppins", fontWeight: 600 }}>
                    Observación del Paciente
                </DialogTitle>

                <DialogContent>
                    <Typography sx={{ fontFamily: "Poppins" }}>
                        {obsSeleccionada}
                    </Typography>
                </DialogContent>
            </Dialog>


            <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: "center" }}>
                        <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
                        <p className="alert-text">{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: "center" }}>
                        <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
                        <p className="alert-text">{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            <Modal open={enviandoAlert}>
                <Box sx={modalStyle}>
                    <section style={{ textAlign: "center", padding: "1rem" }}>
                        <CircularProgress style={{ color: "#2a8d74" }} />
                        <p className="alert-text">Procesando solicitud...</p>
                    </section>
                </Box>
            </Modal>
        </Box>
    );
};
